<script>
	import {onMount} from "svelte";
	import {getPagesFixedRandomContent, setPagesFixedRandomContent} from "../../share/utils";

	export let html;
	export let isRightSide;
	export let pageContentIndex;
	export let attributes;
	let div;
	let maxIndexCount = 0;

	function showRandomMaxBoxes() {
		if(!div) {
			return;
		}
		const divs = div.querySelectorAll('.boxes > div');
		let hideIndexes = [];
		const alreadySetHideIndexes = getPagesFixedRandomContent(isRightSide, pageContentIndex);
		let newMaxIndexCount = div.getAttribute('max_random_desktop');
		if(window.innerWidth < 900) { // = for-tablet-landscape-up
			newMaxIndexCount = div.getAttribute('max_random_tablet');
		}
		if(window.innerWidth < 600) { // = for-tablet-portrait-up
			newMaxIndexCount = div.getAttribute('max_random_mobile');
		}
		if(newMaxIndexCount < 1 || maxIndexCount === newMaxIndexCount) {
			return;
		}
		maxIndexCount = newMaxIndexCount;
		if(alreadySetHideIndexes && alreadySetHideIndexes.length === parseInt(maxIndexCount)) {
			hideIndexes = alreadySetHideIndexes;
		} else {
			while(hideIndexes.length < maxIndexCount){
				const hideIndex = Math.floor(Math.random() * divs.length);
				if(hideIndexes.indexOf(hideIndex) === -1) hideIndexes.push(hideIndex);
			}
		}
		setPagesFixedRandomContent(pageContentIndex, hideIndexes);
		div.querySelectorAll('.boxes > div').forEach((div, i) => {
			div.style.display = 'block';
			if(hideIndexes.indexOf(i) === -1) {
				div.style.display = 'none';
			}
		})
	}

	onMount(() => {
		showRandomMaxBoxes();
		window.addEventListener('resize', () => showRandomMaxBoxes());
	});
</script>

<div bind:this={div} class="image_gallery marginbox" style="
	 --cols-desktop: {attributes.getNamedItem('data-cols-desktop')?.value || 5};
	 --cols-tablet: {attributes.getNamedItem('data-cols-tablet')?.value || 3};
	 --cols-mobile: {attributes.getNamedItem('data-cols-mobile')?.value || 2}
	"
	 max_random_desktop="{attributes.getNamedItem('data-cols-desktop-max-random')?.value || 0}"
	 max_random_tablet="{attributes.getNamedItem('data-cols-tablet-max-random')?.value || 0}"
	 max_random_mobile="{attributes.getNamedItem('data-cols-mobile-max-random')?.value || 0}"
>
	<slot/>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.image_gallery {
		--cols-mobile: 1;
		--cols-tablet: 2;
		--cols-desktop: 2;

		width: calc(100% - ($spacing-mobile * 2));
		margin: $spacing-mobile;

		@include for-tablet-portrait-up {
			width: 100%;
			margin: 0 0 $spacing-mobile-half;
		}

		h3 {
			@include font-px-to-rem(20, 30, 600);

			@include for-tablet-portrait-up {
				margin-bottom: $spacing-mobile*0.25;
			}
		}
		
		h5 {
			margin-bottom: $spacing-mobile*0.25;
		}
		
		> div {
			display: grid;
			grid-template-columns: repeat(var(--cols-mobile), 1fr);
			gap: 1em;
			
			@include for-tablet-portrait-up {
				grid-template-columns: repeat(var(--cols-tablet), 1fr);
			}
			
			@include for-tablet-landscape-up {
				grid-template-columns: repeat(var(--cols-desktop), 1fr);
			}
			
			> div {
				position: relative;
				display: flex;
				flex-direction: column;

				@include for-tablet-portrait-up {
					height: 100%;
				}

				.see_more_button {
					left: 0;
					width: fit-content;
					
					@include for-tablet-portrait-up {
						margin-top: auto;
					}
					
					> a {
						padding-left: $spacing-mobile-half;
						
						@include for-tablet-landscape-up {
							padding-left: 0.8rem;
						}
					}
				}
				
				&:not(:last-of-type) {
					margin-bottom: $media-gap;
					
					@include for-tablet-landscape-up {
						margin-bottom: 0;
					}
				}
			}
			
			img {
				width: 100%;
			}
			
			.img_w40px img {
				width: 40px;
				height: max-content;
				margin-bottom: $spacing-mobile-one-third;
			}

			.img_h40px img {
				width: max-content;
				max-width: 40px;
				height: 40px;
				margin-bottom: $spacing-mobile-one-third;
				position: relative;
				left: 0;
			}
			
			.box--white {
				width: 100%;
				height: fit-content;
				background-color: white;
				padding: $spacing-mobile;
				color: black;
				//aspect-ratio: 1;

				@include for-tablet-portrait-up {
					height: 100%;
				}
				
				h4 {
					margin-bottom: $spacing-mobile-one-third;
				}
			}
		}

		.boxes > div > div {
			overflow: hidden;

			a {
				display: flex;
				align-content: center;
			}
		}

	//	Looks fixed:
	//	.boxes div:not([class*="img"]) {
	//		display: none;
	//	}
	}
</style>
